import app from 'firebase/app';
import firebase from 'firebase'

const config = {
    apiKey: "AIzaSyAqgYp3mB7stBRv1dDsnSdPdD3EgqMoImU",
    authDomain: "skilled-2397f.firebaseapp.com",
    databaseURL: "https://skilled-2397f.firebaseio.com",
    projectId: "skilled-2397f",
    storageBucket: "skilled-2397f.appspot.com",
    messagingSenderId: "762925520058",
    appId: "1:762925520058:web:750796d68ec8ee036d5e83",
    measurementId: "G-9F1Q3JT9TV",
};


// class Firebase {
//     constructor() {
//       firebase.initializeApp(config);
        
//         }

          
//     }

firebase.initializeApp(config);
export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export default firebase;